/**
 * What the voice reads is not what the screen shows.
 *
 * The tutor writes for a child reading a screen, and that includes the odd
 * `**fett**` and the occasional `\frac{1}{2}`. Read aloud, those become "sternchen
 * fett sternchen" and "backslash frac", which is the single most jarring thing
 * a spoken tutor can do. This strips the markup before anything is spoken.
 */
export function forSpeech(text: string): string {
  return text
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`([^`]*)`/g, '$1')
    .replace(/\$\$([\s\S]*?)\$\$/g, (_, m: string) => math(m))
    .replace(/\$([^$]*)\$/g, (_, m: string) => math(m))
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/[*_#>]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

// math turns the handful of LaTeX forms this tutor actually writes into German
// a voice can say. Anything else loses its backslashes and braces and is read
// as the symbols it is, which is closer to right than reading "backslash".
function math(expr: string): string {
  return expr
    .replace(/\\frac\{([^{}]*)\}\{([^{}]*)\}/g, '$1 geteilt durch $2')
    .replace(/\\sqrt\{([^{}]*)\}/g, 'Wurzel aus $1')
    .replace(/\\cdot|\\times/g, ' mal ')
    .replace(/\\div/g, ' geteilt durch ')
    .replace(/\\pm/g, ' plus minus ')
    .replace(/\\left|\\right/g, '')
    .replace(/\\[a-zA-Z]+/g, ' ')
    .replace(/[{}]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** A date the way a parent reads one. */
export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: 'short' });
}

/** A date and time, for a session row. */
export function dateTime(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Cents, in euro, the way a price is written here. */
export function euro(cents: number): string {
  return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}
